import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  colorBox: {
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
  },
  caption: {
    marginLeft: '0.5rem',
  },
}));
